// assets/cart-limit.js
console.log('[cart-limit] script loaded');

document.addEventListener('DOMContentLoaded', () => {
  // const API_BASE = 'http://localhost:3000';
  const API_BASE = 'cart-limit-production-9e73.up.railway.app'
  const CHECK_LIMIT_URL = `${API_BASE}/check-limit`;
  const ADD_PURCHASE_URL = `${API_BASE}/add-purchase`;

  // ================= LOGIN / ANALYTICS =================
  function isLoggedIn() {
    try {
      const page = window.ShopifyAnalytics?.meta?.page;
      const loggedIn = !!(page?.customerId && page.customerId !== 0);
      return loggedIn;
    } catch {
      return false;
    }
  }

  function getCustomerKey() {
    try {
      const page = window.ShopifyAnalytics?.meta?.page;
      if (page?.customerId && page.customerId !== 0) {
        return page.customerEmail || `id:${page.customerId}`;
      }
    } catch {}
    return 'guest';
  }

  // ================= ALERT (ONCE) =================
  let alertLock = false;
  function alertOnce(msg) {
    if (alertLock) return;
    alertLock = true;
    alert(msg);
    setTimeout(() => { alertLock = false; }, 1500);
  }

  // ================= ELEMENT HELPERS =================
  function isCheckoutElement(el) {
    if (!el || el.nodeType !== 1) return false;
    const tag = el.tagName.toLowerCase();

    if (
      (tag === 'button' || tag === 'input') &&
      (el.name === 'checkout' || el.getAttribute('data-checkout') !== null)
    ) return true;

    if (tag === 'a') {
      const href = el.getAttribute('href') || '';
      if (href.startsWith('/checkout')) return true;
    }

    if (
      el.classList.contains('shopify-payment-button__button') ||
      el.closest('.shopify-payment-button')
    ) return true;

    return false;
  }

  function isAddToCartElement(el) {
    if (!el || el.nodeType !== 1) return false;

    const tag = el.tagName.toLowerCase();
    const name = el.getAttribute('name') || '';
    const type = el.getAttribute('type') || '';
    const classes = el.classList;

    if (
      (tag === 'button' || tag === 'input') &&
      (name === 'add' ||
        classes.contains('product-form__submit') ||
        classes.contains('add-to-cart') ||
        el.getAttribute('data-add-to-cart') !== null)
    ) return true;

    const form = el.closest('form[action^="/cart/add"]');
    if (form && (tag === 'button' || tag === 'input') && type === 'submit') return true;

    return false;
  }

  // Qty “increase” buttons vary by theme. These catch most themes.
  function isQtyIncreaseButton(el) {
    if (!el || el.nodeType !== 1) return false;

    const btn = el.closest('button, a, input');
    if (!btn) return false;

    const tag = btn.tagName.toLowerCase();
    const type = (btn.getAttribute('type') || '').toLowerCase();
    const name = (btn.getAttribute('name') || '').toLowerCase();
    const aria = (btn.getAttribute('aria-label') || '').toLowerCase();
    const cls = (btn.className || '').toLowerCase();
    const dataAction = (btn.getAttribute('data-action') || '').toLowerCase();

    // Common patterns
    if (aria.includes('increase') || aria.includes('plus')) return true;
    if (name === 'plus' || name === 'increment') return true;
    if (dataAction === 'increase' || dataAction === 'increment') return true;
    if (cls.includes('qty__button') && cls.includes('plus')) return true;
    if (cls.includes('quantity') && (cls.includes('plus') || cls.includes('increment'))) return true;
    if (cls.includes('cart') && cls.includes('qty') && (cls.includes('plus') || cls.includes('increment'))) return true;

    // Some themes use +/- buttons inside a quantity wrapper
    const wrapper = btn.closest('.quantity, .qty, .cart__qty, .quantity-selector, [data-quantity-selector]');
    if (wrapper) {
      // heuristic: right-side button often increases; also look for "+" text
      const txt = (btn.textContent || '').trim();
      if (txt === '+' || txt === '＋') return true;
      // if it's not clearly decrement/minus, treat as potential increment
      if (!aria.includes('decrease') && !cls.includes('minus') && !name.includes('minus')) {
        // but only if it’s near a number input
        if (wrapper.querySelector('input[type="number"]')) return true;
      }
    }

    // Reject submits (avoid interfering with unrelated forms)
    if (tag === 'input' && type === 'submit') return false;

    return false;
  }

  // ================= CART HELPERS =================
  async function getCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  async function getCartQuantityForVariant(variantId) {
    const cart = await getCart();
    const line = cart?.items?.find((i) => String(i.variant_id) === String(variantId));
    return line ? line.quantity : 0;
  }

  async function getCartItems() {
    const cart = await getCart();
    return cart?.items || [];
  }

  // ================= API =================
  async function checkLimit({ variantId, quantity, requestedTotal }) {
    const payload = {
      variantId: String(variantId),
      customerKey: getCustomerKey(),
      quantity,
      requestedTotal,
    };

    console.log('[cart-limit] checking limit payload', payload);

    let res;
    try {
      res = await fetch(CHECK_LIMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.warn('[cart-limit] /check-limit network error; failing open', err);
      return { allowed: true };
    }

    if (!res.ok) {
      console.warn('[cart-limit] /check-limit non-200; failing open', res.status);
      return { allowed: true };
    }

    return await res.json();
  }

  // ================= FORCE REMOVE (QTY=0) =================
  function urlEncodedHeaders() {
    return { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
  }

  async function removeVariant(variantId) {
    try {
      const body = new URLSearchParams();
      body.set(`updates[${String(variantId)}]`, '0');

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: urlEncodedHeaders(),
        credentials: 'same-origin',
        body: body.toString(),
      });

      console.log('[cart-limit] removeVariant update.js status', res.status);
    } catch (err) {
      console.warn('[cart-limit] removeVariant error', err);
    }

    // Reload to force UI to match server (themes often re-render)
    window.location.reload();
  }

  // ================= VARIANT RESOLUTION IN CART =================
  function parseVariantIdFromUpdatesInputName(name) {
    // name like: updates[1234567890]
    const m = String(name || '').match(/^updates\[(\d+)\]$/);
    return m ? m[1] : null;
  }

  async function resolveVariantIdFromCartRow(clickedEl) {
    // Prefer nearest qty input
    const row =
      clickedEl.closest('.cart-item, .cart__row, [data-cart-item], tr, li, div') || document;

    const numberInput =
      row.querySelector('input[type="number"][name^="updates"]') ||
      row.querySelector('input[type="number"][name="updates[]"]') ||
      row.querySelector('input[type="number"]');

    // 1) updates[VARIANT]
    if (numberInput?.name) {
      const vid = parseVariantIdFromUpdatesInputName(numberInput.name);
      if (vid) return { variantId: vid, inputEl: numberInput };
    }

    // 2) data-variant-id on row or parent
    const dv =
      row.getAttribute('data-variant-id') ||
      row.closest('[data-variant-id]')?.getAttribute('data-variant-id');
    if (dv) return { variantId: String(dv), inputEl: numberInput };

    // 3) line / index attributes -> map to /cart.js
    const lineAttr =
      row.getAttribute('data-line') ||
      row.getAttribute('data-index') ||
      row.getAttribute('data-cart-line') ||
      numberInput?.getAttribute('data-line') ||
      numberInput?.getAttribute('data-index');

    const line = lineAttr ? parseInt(String(lineAttr), 10) : NaN;
    if (Number.isFinite(line) && line > 0) {
      const cart = await getCart();
      const item = cart?.items?.[line - 1];
      if (item?.variant_id) return { variantId: String(item.variant_id), inputEl: numberInput };
    }

    // 4) fallback: DOM order of qty inputs maps to cart.items order
    {
      const cart = await getCart();
      const allQtyInputs = Array.from(
        document.querySelectorAll('input[type="number"][name^="updates"], input[type="number"][name="updates[]"]')
      );
      if (cart?.items?.length && numberInput) {
        const idx = allQtyInputs.indexOf(numberInput);
        if (idx >= 0 && cart.items[idx]?.variant_id) {
          return { variantId: String(cart.items[idx].variant_id), inputEl: numberInput };
        }
      }
    }

    return { variantId: null, inputEl: numberInput };
  }

  function parseIntSafe(v, fallback) {
    const n = parseInt(String(v ?? ''), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  // ================= ADD-TO-CART HANDLER =================
  function findVariantIdOnProductForm(form, clickedNode) {
    const idField =
      form.querySelector('[name="id"]') ||
      form.querySelector('[name="variant_id"]');
    if (idField?.value) return String(idField.value);

    const dataVarEl =
      clickedNode.closest('[data-variant-id]') ||
      form.querySelector('[data-variant-id]');
    if (dataVarEl) {
      const val = dataVarEl.getAttribute('data-variant-id');
      if (val) return val;
    }

    return null;
  }

  async function handleAddToCart(node) {
    const form =
      node.closest('form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    const variantId = findVariantIdOnProductForm(form, node);
    if (!variantId) {
      console.warn('[cart-limit] no variant id; submitting anyway');
      form.submit();
      return;
    }

    const qtyInput = form.querySelector('input[name="quantity"]');
    const addQty = parseIntSafe(qtyInput?.value, 1);

    const existing = await getCartQuantityForVariant(variantId);
    const requestedTotal = existing + addQty;

    const res = await checkLimit({ variantId, quantity: addQty, requestedTotal });
    if (!res.allowed) {
      alertOnce(res.message || 'You have reached the purchase limit for this item.');
      return;
    }

    form.submit();
  }

  // ================= CHECKOUT =================
  async function sendCartToAddPurchase() {
    const customerKey = getCustomerKey();
    const items = await getCartItems();
    if (!items.length) return;

    const payload = {
      customerKey,
      items: items.map((i) => ({
        variantId: String(i.variant_id),
        quantity: i.quantity,
      })),
    };

    try {
      const res = await fetch(ADD_PURCHASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        console.warn('[cart-limit] /add-purchase failed', res.status, await res.text());
      }
    } catch (err) {
      console.warn('[cart-limit] /add-purchase network error', err);
    }
  }

  function proceedToCheckout() {
    window.location.href = '/checkout';
  }

  // ================= GLOBAL CLICK INTERCEPTOR (WORKING STYLE) =================
  document.addEventListener(
    'click',
    async (e) => {
      const loggedIn = isLoggedIn();

      // Walk up for targets
      let node = e.target;
      let addNode = null;
      let checkoutNode = null;
      let qtyPlusNode = null;

      while (node && node !== document.documentElement) {
        if (!qtyPlusNode && isQtyIncreaseButton(node)) qtyPlusNode = node;
        if (!addNode && isAddToCartElement(node)) addNode = node;
        if (!checkoutNode && isCheckoutElement(node)) checkoutNode = node;
        if (qtyPlusNode || addNode || checkoutNode) break;
        node = node.parentElement;
      }

      // Guest: block add-to-cart & checkout
      if (!loggedIn) {
        if (addNode || checkoutNode || qtyPlusNode) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alertOnce('Please login or create an account to continue.');
          window.location.href = '/account/login';
        }
        return;
      }

      // Logged in: intercept quantity increase clicks in cart
      if (qtyPlusNode) {
        // Stop the theme from applying the increment first
        e.preventDefault();
        e.stopImmediatePropagation();

        const { variantId, inputEl } = await resolveVariantIdFromCartRow(qtyPlusNode);
        if (!variantId) {
          console.warn('[cart-limit] qty+ click: could not resolve variant id; allowing');
          // If we can’t resolve, fail open: trigger the click again without intercept
          // (rare)
          return;
        }

        const currentQty = parseIntSafe(inputEl?.value, null);
        const newQty = (currentQty == null ? 1 : currentQty + 1);

        const res = await checkLimit({ variantId, quantity: 1, requestedTotal: newQty });

        if (!res.allowed) {
          alertOnce(res.message || 'You have reached the purchase limit for this item.');
          await removeVariant(variantId); // sets to 0 and reloads
          return;
        }

        // Allowed: perform the increment via Shopify update endpoint so it applies
        try {
          const body = new URLSearchParams();
          body.set(`updates[${String(variantId)}]`, String(newQty));

          const ures = await fetch('/cart/update.js', {
            method: 'POST',
            headers: urlEncodedHeaders(),
            credentials: 'same-origin',
            body: body.toString(),
          });

          if (!ures.ok) {
            console.warn('[cart-limit] update.js failed', ures.status);
          }
        } catch (err) {
          console.warn('[cart-limit] update.js network error', err);
        }

        window.location.reload();
        return;
      }

      // Logged in: enforce limit on add-to-cart
      if (addNode) {
        e.preventDefault();
        e.stopImmediatePropagation();
        await handleAddToCart(addNode);
        return;
      }

      // Logged in: checkout flow
      if (checkoutNode) {
        e.preventDefault();
        e.stopImmediatePropagation();
        await sendCartToAddPurchase();
        proceedToCheckout();
        return;
      }
    },
    { capture: true }
  );

  console.log('[cart-limit] click interceptors installed');
});